import { UserCardItem, CardSegment } from 'controller/card';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CardState {
  cardList: UserCardItem[];
  current: number;
  size: number;
  refresh: number;
  total: number;
  selectedRowKeys: string[];
  loading: boolean;
  initLoading: boolean;
  loadingIndex: number;
  filter: any;
  cardSegmentList: CardSegment[];
}

export const initialState: CardState = {
  cardList: [],
  current: 1,
  size: 10,
  total: 0,
  selectedRowKeys: [],
  loading: true,
  initLoading: true,
  loadingIndex: -1,
  refresh: 0,
  filter: {},
  cardSegmentList: []
};

export interface ActionType {
  type: string;
  payload: Partial<CardState>;
}

export const cardSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    CARD_INIT: (state, action: any) => {
      state = {
        ...initialState
      };
      return state;
    },
    CARD_UPDATE: (state, action: PayloadAction<Partial<CardState>>) => {
      state = {
        ...state,
        ...(action.payload || {})
      };
      return state;
    }
  }
});

export const { CARD_INIT, CARD_UPDATE } = cardSlice.actions;

export default cardSlice.reducer;
